// ----------------------------------------------------
//  This class helps with firebase querys etc.
// ----------------------------------------------------

import fb from '@/shift/fb';
//import agile from '@/shift/agile';


const agileFb =
{
	updateSecurityRules()
	{
		const updateSecurityRules = fb.functions.httpsCallable('updateSecurityRules');

		updateSecurityRules()
		.then(result =>
		{
			console.log("* Updated security rules", result);
		})
		.catch(er =>
		{
			console.log("*Error security rules", er);
		});
	},

	updateUsersAccessCards()
	{
		const updateUsersAccessCards = fb.functions.httpsCallable('updateUsersAccessCards');

		updateUsersAccessCards()
		.then(result =>
		{
			console.log("* Updated access cards", result);
		})
		.catch(er =>
		{
			console.log("*Error updating access cards", er);
		});
	},


	// ----------------------------------
	//	Get deletion query
	// ----------------------------------
	
	getDevQueryStart(key, collection)
	{
		return fb.db
			.collection('dev-collection')
			.doc('dev-doc')
			.collection(key)
			.doc(key)
			.collection(collection);
	},


    // ----------------------------------
    //	List accessible projects for user
    // ----------------------------------

    /* listUserProjects(callBackDone, callBackError)
    {
		callBackDone; callBackError;
        fb.db.collection('projects').where('disabled', '==', false).get()
		.then((querySnapshot) =>
		{
            // Clear old project list for user
            agile.loggedInUser.projects = [];

			// Loop projects
			querySnapshot.forEach((doc) =>
			{
				const docData = doc.data();
				console.log('***', docData.projectName);
				agile.loggedInUser.projects.push( 
				{
					id: doc.id,
					name: docData.name,
					key: docData.key,
					variable: docData.variable,
					accessMap: docData.accessMap,
                    clientName: docData.clientName,
					groupName: docData.groupName,
					projectName: docData.projectName,
					prettyName: docData.prettyName,
				});
			});
			
            //agile.sortBy(agile.loggedInUser.projects, 'clientName');
            //console.log(agile.loggedInUser.projects);
			//return true;
		})
		.catch((error) =>
		{
            console.log("Error", error);
            //return false;
		});
    }, */
 /**/

    /* setActiveProject(key)
    {
        fb.db.collection('users').doc(agile.loggedInUser.uid).set( { currentProject: key }, { merge: true } )
		.then(() =>
		{
            console.log('Current project set for user:', key);
		})
		.catch((error) =>
		{
            console.log("Error", error);
            //return false;
		});
    } */

};

export default agileFb;